(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-marquee"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialize(scope) {
    scope.querySelectorAll('.hero-marquee').forEach((root) => {
      if (root.dataset.videoPlaybackReady) return;
      root.dataset.videoPlaybackReady = 'true';
      const videos = Array.from(root.querySelectorAll('video[data-hero-video]'));
      const visible = new Set();
      const pending = new WeakSet();
      const buttons = new Map();
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const abort = new AbortController();
      const options = { signal: abort.signal };
      function play(video, manual = false) {
        if (document.hidden || !visible.has(video) || pending.has(video)) return;
        const button = buttons.get(video);
        if (motion.matches && !manual) { button.hidden = false; return; }
        if (!video.paused) return;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        if (manual && video.error) video.load();
        pending.add(video);
        video.play().then(() => {
          button.hidden = true;
          if (!visible.has(video) || document.hidden) video.pause();
        }).catch(() => {
          button.hidden = false;
        }).finally(() => pending.delete(video));
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(({ target: video, isIntersecting, intersectionRatio }) => {
          if (isIntersecting && intersectionRatio > 0.05) {
            visible.add(video);
            play(video);
          } else {
            visible.delete(video);
            video.pause();
          }
        });
      }, { threshold: [0, 0.05] });
      videos.forEach((video) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'hero-marquee__play';
        button.textContent = 'Play video';
        button.hidden = true;
        if (video.closest('[aria-hidden="true"]')) button.tabIndex = -1;
        video.parentElement.appendChild(button);
        buttons.set(video, button);
        video.controls = false;
        video.muted = true;
        video.defaultMuted = true;
        button.addEventListener('click', () => play(video, true), options);
        video.addEventListener('playing', () => { button.hidden = true; }, options);
        video.addEventListener('error', () => {
          button.hidden = false;
          button.textContent = 'Retry video';
        }, options);
        observer.observe(video);
      });
      const resume = () => visible.forEach((video) => play(video));
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) videos.forEach((video) => video.pause());
        else resume();
      }, options);
      window.addEventListener('pageshow', resume, options);
      motion.addEventListener('change', () => {
        if (motion.matches) videos.forEach((video) => video.pause());
        resume();
      }, options);
      root.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
        observer.disconnect();
        videos.forEach((video) => video.pause());
        abort.abort();
      }, { once: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
